import {
  PROJECT_REQUEST,
  PROJECTINFO,
  PROJECTCATEGORY,
  request,
  success,
  failure,
} from "./utilities";
import {
  fetchProjects,
  fetchProjectsByFilter,
  changeProject,
  fetchProjectCategory,
  createProjectTask,
  fetchProjectInfo,
  removeProject,
  getProjectSelectListByRoleApi,
  emptyTrashApi,
  getDeleteProjectListApi,
  restoreDeleteProjectApi,
  deleteTrashProjectApi,
  fetchProjectsByEmployee,
  fetchEmployeeTasksByProject,
  removeUserFromProject,
} from "../api";
import { GetRequest, PostRequest } from "../api/genericApiCalls";
import { APP_SETTINGS } from "../../config";

export function getProjectsByEmployeeAction(organizationId, empId, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_PROJECTS_BY_EMPLOYEE_REQUEST));

    fetchProjectsByEmployee(organizationId, empId, token)
      .then((res) => {
        if (res.data.status === 200) {
          dispatch(
            success(
              PROJECT_REQUEST.GET_PROJECTS_BY_EMPLOYEE_SUCCESS,
              res.data.data,
            ),
          );
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.GET_PROJECTS_BY_EMPLOYEE_FAILURE,
              res.data.message,
            ),
          );
        }
      })
      .catch((error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_PROJECTS_BY_EMPLOYEE_FAILURE,
            error?.response?.data?.title || error.message,
          ),
        );
      });
  };
}

export function removeUserFromProjectAction(projectId, userId, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.REMOVE_USER_FROM_PROJECT_REQUEST));

    return removeUserFromProject(projectId, userId, token)
      .then((res) => {
        if (res.status === 200) {
          dispatch({
            type: PROJECT_REQUEST.REMOVE_USER_FROM_PROJECT_SUCCESS,
            payload: {
              projectId,
              userId,
              message: res.data.message,
            },
          });
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.REMOVE_USER_FROM_PROJECT_FAILURE,
              res.data.message,
            ),
          );
        }
        return res; // Return response to allow chaining `.then()`
      })
      .catch((error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.REMOVE_USER_FROM_PROJECT_FAILURE,
            error?.response?.data?.message || error.message,
          ),
        );
        throw error; // Ensure errors propagate properly
      });
  };
}
export function getEmployeeTasksByProject(
  organizationId,
  empId,
  projectId,
  token,
) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_EMPLOYEE_TASKS_REQUEST));

    fetchEmployeeTasksByProject(organizationId, empId, projectId, token)
      .then((res) => {
        if (res.data.status === 200) {
          dispatch(
            success(PROJECT_REQUEST.GET_EMPLOYEE_TASKS_SUCCESS, res.data.data),
          );
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.GET_EMPLOYEE_TASKS_FAILURE,
              res.data.message,
            ),
          );
        }
      })
      .catch((error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_EMPLOYEE_TASKS_FAILURE,
            error?.response?.data?.title || error.message,
          ),
        );
      });
  };
}

export function getRunningProjectsByFilter(data, token) {
  //  ;
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_PROJECT_REQUEST));

    fetchProjectsByFilter(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(PROJECT_REQUEST.GET_PROJECT_SUCCESS, res.data.data));
        } else {
          dispatch(
            failure(PROJECT_REQUEST.GET_PROJECT_FAILURE, res.data.message),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function getNextRunningProjectsByFilter(data, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_NEXT_PROJECT_REQUEST));
    fetchProjectsByFilter(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(PROJECT_REQUEST.GET_NEXT_PROJECT_SUCCESS, res.data.data),
          );
        } else {
          dispatch(
            failure(PROJECT_REQUEST.GET_NEXT_PROJECT_FAILURE, res.data.message),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_NEXT_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function getRunningProjects(requestId, token) {
  //  ;
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_PROJECT_REQUEST));
    fetchProjects(requestId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(PROJECT_REQUEST.GET_PROJECT_SUCCESS, res.data.data));
        } else {
          dispatch(
            failure(PROJECT_REQUEST.GET_PROJECT_FAILURE, res.data.message),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function getProjectCategory(requestId, token) {
  return (dispatch) => {
    dispatch(request(PROJECTCATEGORY.GET_PROJECT_CATEGORY_REQUEST));
    fetchProjectCategory(requestId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECTCATEGORY.GET_PROJECT_CATEGORY_SUCCESS,
              res.data.data,
            ),
          );
        } else {
          dispatch(
            failure(
              PROJECTCATEGORY.GET_PROJECT_CATEGORY_FAILURE,
              res.data.message,
            ),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTCATEGORY.GET_PROJECT_CATEGORY_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function getProjectInfo(token) {
  return (dispatch) => {
    dispatch(request(PROJECTINFO.GET_PROJECT_INFO_REQUEST));
    fetchProjectInfo(token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(PROJECTINFO.GET_PROJECT_INFO_SUCCESS, res.data.data),
          );
        } else {
          dispatch(
            failure(PROJECTINFO.GET_PROJECT_INFO_FAILURE, res.data.message),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECTINFO.GET_PROJECT_INFO_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function addProject(projectData, goBack, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.ADD_PROJECT_REQUEST));
    changeProject(projectData, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(PROJECT_REQUEST.ADD_PROJECT_SUCCESS, res.data.data));
          if (goBack) {
            goBack();
          }
        } else {
          dispatch(
            failure(PROJECT_REQUEST.ADD_PROJECT_FAILURE, res.data.message),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.ADD_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function editProject(projectData, goBack, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.EDIT_PROJECT_REQUEST));
    changeProject(projectData, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(PROJECT_REQUEST.EDIT_PROJECT_SUCCESS, res.data.data),
          );
          if (goBack) {
            goBack();
          }
        } else {
          dispatch(
            failure(PROJECT_REQUEST.EDIT_PROJECT_FAILURE, res.data.message),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.EDIT_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function addProjectTask(task, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.ADD_PROJECT_TASK_REQUEST));
    createProjectTask(task, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(PROJECT_REQUEST.ADD_PROJECT_TASK_SUCCESS, res.data.data),
          );
        } else {
          dispatch(
            failure(PROJECT_REQUEST.ADD_PROJECT_TASK_FAILURE, res.data.message),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.ADD_PROJECT_TASK_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function deleteProject(projectId, token, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.DELETE_PROJECT_REQUEST));
    removeProject(projectId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(PROJECT_REQUEST.DELETE_PROJECT_SUCCESS, res.data.data),
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(res.data.message, "success");
          }
        } else {
          dispatch(
            failure(PROJECT_REQUEST.DELETE_PROJECT_FAILURE, res.data.message),
          );
          if (Notification) {
            Notification(res.data.message, "success");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.DELETE_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function GetProjectByIdAction(projectId, infoObject, token) {
  //  ;
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_PROJECT_ON_RELOAD_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.PROJECTS.getProjectById}?projectId=${projectId}`;
    GetRequest(path, token).then(
      (res) => {
        //  ;
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECT_REQUEST.GET_PROJECT_ON_RELOAD_SUCCESS,
              res.data.data,
              infoObject,
            ),
          );
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.GET_PROJECT_ON_RELOAD_FAILURE,
              res.data.message,
            ),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_PROJECT_ON_RELOAD_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function getProjectSelectListByRole(orgId, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_PROJECT_SELECT_LIST_BY_ROLE_REQUEST));
    getProjectSelectListByRoleApi(orgId, token).then(
      (response) => {
        // console.log('teamMembers  resp', response);
        if (response.data.status === 1) {
          dispatch(
            success(
              PROJECT_REQUEST.GET_PROJECT_SELECT_LIST_BY_ROLE_SUCCESS,
              response.data.data,
            ),
          );
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.GET_PROJECT_SELECT_LIST_BY_ROLE_FAILURE,
              response.data.message,
            ),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_PROJECT_SELECT_LIST_BY_ROLE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.message
              ? error.response.data.message
              : error.message,
          ),
        );
      },
    );
  };
}

export function getDeleteProjectListAction(data, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.GET_DELETE_PROJECT_LIST_REQUEST));
    getDeleteProjectListApi(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECT_REQUEST.GET_DELETE_PROJECT_LIST_SUCCESS,
              res.data.data,
            ),
          );
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.GET_DELETE_PROJECT_LIST_FAILURE,
              res.data.message,
            ),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.GET_DELETE_PROJECT_LIST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}

export function restoreDeleteProjectAction(data, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.RESTORE_DELETE_PROJECT_REQUEST));
    restoreDeleteProjectApi(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECT_REQUEST.RESTORE_DELETE_PROJECT_SUCCESS,
              res.data.data,
            ),
          );
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.RESTORE_DELETE_PROJECT_FAILURE,
              res.data.message,
            ),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.RESTORE_DELETE_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}
export function deleteTrashProjectAction(
  projectId,
  token,
  moveToNext,
  Notification,
) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.DELETE_TRASH_PROJECT_REQUEST));
    deleteTrashProjectApi(projectId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECT_REQUEST.DELETE_TRASH_PROJECT_SUCCESS,
              res.data.data,
            ),
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(res.data.message, "success");
          }
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.DELETE_TRASH_PROJECT_FAILURE,
              res.data.message,
            ),
          );
          if (Notification) {
            Notification(res.data.message, "success");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.DELETE_TRASH_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message,
          ),
        );
      },
    );
  };
}
export function emptyTrashAction(orgId, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_REQUEST.EMPTY_TRASH_PROJECT_REQUEST));
    emptyTrashApi(orgId, token).then(
      (response) => {
        // console.log('teamMembers  resp', response);
        if (response.data.status === 1) {
          dispatch(
            success(
              PROJECT_REQUEST.EMPTY_TRASH_PROJECT_SUCCESS,
              response.data.data,
            ),
          );
        } else {
          dispatch(
            failure(
              PROJECT_REQUEST.EMPTY_TRASH_PROJECT_FAILURE,
              response.data.message,
            ),
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_REQUEST.EMPTY_TRASH_PROJECT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.message
              ? error.response.data.message
              : error.message,
          ),
        );
      },
    );
  };
}
